import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      Tiu domo, verŝajne, estas jam ducentjara. 
      Ĝi staras malgranda, kaduka, kaj sentas sin embarasite inter belaj modernaj domoj.
    </p>
    
    <p class="mb-3">
      Malfacilas eĉ kompreni, pro kiu miraklo ĝi konserviĝis. 
      Ĝian bruston ne ornamas memortabuloj, ĝiajn murojn ne subtenas la aŭtoritato de grandaj homoj, kiuj loĝis aŭ almenaŭ noktumis tie.
    </p>
    
    <p class="mb-3">
      Sed tamen, ne vane ĝi eltenis dum tiom da jaroj; ja en ĝi ĉiam loĝis homoj.
    </p>
    
    <p class="mb-3">
      Eble, ankaŭ ili estis grandaj homoj; nur neniu rimarkis tion?
    </p>
    `
  )
}

const itemName = {
  esp: 'Malnova domo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;